import { Reducer } from 'react';
import { GlobalSearchState } from '../../interfaces/global-search';

export enum GlobalSearchReducerActionType {
  BULK_UPDATE = 'BULK_UPDATE',
  GET_ENTITY_DATA = 'GET_ENTITY_DATA',
  UPDATE_ENTITY_DATA = 'UPDATE_ENTITY_DATA',
  FILTER_DATA = 'FILTER_DATA'
}

export interface GlobalSearchReducerAction {
  type: GlobalSearchReducerActionType;
  entity?: string;
  data?: object;
}

export type GlobalSearchReducerType = Reducer<GlobalSearchState, GlobalSearchReducerAction>;

export interface GlobalSearchReducerActions {
  getEntityData: (entity: string) => void;
  updateEntityData: (entity: string, data: object) => void;
  bulkUpdateState: (data: object) => void;
  filterData: (filters: object) => void;
}
